module.exports = __webpack_public_path__ + "img/symbol_7.4f736a0d.png";